import React from "react"
import Details from "./Details"
import FormWrapper from "./FormWrapper"
import * as Yup from "yup"
import BuildingProject from "./new-build/BuildingProject"
import Goals from "./renovation/Goals"
import Designer from "./new-build/Designer"
import Builder from "./new-build/Builder"
import AdditionalInformation from "./new-build/AdditionalInformation"
import TimeToContact from "./TimeToContact"

export default function CustomForm({ portalId, formId, uniqueQuestion, ...props }) {
  return(
    <FormWrapper
      initialValues={initialValues}
      validationSchema={validationSchema}
      portalId={portalId}
      formId={formId}
    >
      <Details/>
      <BuildingProject/>
      <Goals
        uniqueQuestion={uniqueQuestion}
      />
      <Designer/>
      <Builder/>
      <AdditionalInformation/>
      <TimeToContact/>
    </FormWrapper>
  )
}

const initialValues = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  address: "",
  postal_code: "",
  city: "",
  state: "",
  property: "",
  finance: "",
  price_guide: "",
  time_frame: "",
  project_description: "",
  project_qualities: [],
  external_features: [],
  internal_features: [],
  kitchen: [],
  bathroom_ensuite_features: [],
  electrical_gas_features: [],
  renovation_design_goals_exist: "",
  renovation_design_goals: "",
  material_preference_or_sustainability_factor: "",
  material_preference_or_sustainability: "",
  designer_required: "",
  builder_finders_refer_designer_architect: "",
  designer_name: "",
  designer_number: "",
  designer_email: "",
  builder_considered: "",
  list_of_builders_considered: "",
  builder_attributes_desired: "",
  others_involved_in_project_decisions: "",
  additional_information: "",
  fullname_preferred_contact: "",
  phone_preferred_contact: "",
  date_preferred_contact: "",
}

const validationSchema = {
  firstname: Yup.string().required("Your first name is required."),
  lastname: Yup.string().required("Your last name is required."),
  email: Yup.string()
    .email("Invalid email address.")
    .required("Your email is required."),
  phone: Yup.string().required("A contact number is required."),
  address: Yup.string().required("Please complete this required field."),
  postal_code: Yup.string().required("Please complete this required field."),
  city: Yup.string().required("Please complete this required field."),
  state: Yup.string().required("Please complete this required field."),
  property: Yup.string().required("Please complete this required field."),
  finance: Yup.string().required("Please complete this required field."),
  price_guide: Yup.string().required("Please complete this required field."),
  time_frame: Yup.string().required("Please complete this required field."),
  project_description: Yup.string().required("Please complete this required field."),
  project_qualities: Yup.array().min(1, "At least one option must be selected."),
  renovation_design_goals_exist: Yup.string().required("Please complete this required field."),
  renovation_design_goals: Yup.string().when("renovation_design_goals_exist", {
    is: value => value && value === "yes",
    then: Yup.string().required("Please complete this required field."),
    otherwise: Yup.string()
  }),
  material_preference_or_sustainability_factor: Yup.string().required("Please complete this required field."),
  material_preference_or_sustainability: Yup.string().when("material_preference_or_sustainability_factor", {
    is: value => value && value === "yes",
    then: Yup.string().required("Please complete this required field."),
    otherwise: Yup.string()
  }),
  designer_required: Yup.string().required("Please complete this required field."),
  builder_finders_refer_designer_architect: Yup.string().when("designer_required", {
    is: value => value && value === "yes",
    then: Yup.string().required("Please complete this required field."),
    otherwise: Yup.string()
  }),
  designer_name: Yup.string().when("designer_required", {
    is: value => value && value === "no",
    then: Yup.string().required("Please complete this required field."),
    otherwise: Yup.string()
  }),
  designer_number: Yup.string().when("designer_required", {
    is: value => value && value === "no",
    then: Yup.string().required("Please complete this required field."),
    otherwise: Yup.string()
  }),
  designer_email: Yup.string().when("designer_required", {
    is: value => value && value === "no",
    then: Yup.string().required("Please complete this required field."),
    otherwise: Yup.string()
  }),
  builder_considered: Yup.string().required("Please complete this required field."),
  list_of_builders_considered: Yup.string().when("builder_considered", {
    is: value => value && value === "yes",
    then: Yup.string().required("Please complete this required field."),
    otherwise: Yup.string()
  }),
  builder_attributes_desired: Yup.string().when("builder_considered", {
    is: value => value && value === "no",
    then: Yup.string().required("Please complete this required field."),
    otherwise: Yup.string()
  }),
  others_involved_in_project_decisions: Yup.string().required("Please complete this required field."),
  additional_information: Yup.string(),
  fullname_preferred_contact: Yup.string().required("Please complete this required field."),
  phone_preferred_contact: Yup.string().required("Please complete this required field."),
  date_preferred_contact: Yup.string().required("Please complete this required field."),
}